<template>
  <el-dialog
    title="修改医生信息"
    :visible.sync="dialog"
    width="650px"
    style="text-align: left"
    :close-on-click-modal="false"
    append-to-body
    class="big"
    :show-close="false"
  >
    <div style="padding: 20px 0 20px 20px">
      <div class="container">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="90px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="医生头像"
            prop="head_img"
            style="margin-bottom: 70px"
          >
            <!-- 头像上传 -->
            <div class="headimg">
              <el-upload
                class="avatar-uploader"
                name="image"
                accept=".png,.jpeg,.jpg"
                :action="uploadUrl"
                :data="uploadExtraData"
                :headers="uploadHeaders"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="head_img" :src="head_img" class="avatar" />
                <div v-else>
                  <i class="el-icon-plus uploader-icon"></i>
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="姓名" prop="doctor_name">
            <el-input
              v-model="ruleForm.doctor_name"
              class="myinput"
              maxlength="10"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="医院名称" prop="hospital">
            <el-input
              v-model="ruleForm.hospital"
              class="myinput"
              maxlength="20"
              placeholder="请填写目前执业的医院"
            ></el-input>
          </el-form-item>
          <el-form-item label="擅长方向" id="begoodatitem">
            <div>
              <div
                class="selectgoodlist"
                id="begoodat"
                @click="showgoodlist = true"
              >
                <el-tag
                  :key="index"
                  v-for="(tag, index) in goodTags"
                  type="info"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                  >{{ tag.be_good_at_name }}</el-tag
                >
              </div>

              <div class="goodlist" v-if="showgoodlist">
                <div class="search">
                  <el-input
                    placeholder="请输入内容"
                    v-model="goodlistKeyword"
                    class="input-with-select"
                    clearable
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="getGoodList"
                    ></el-button>
                  </el-input>
                </div>

                <template v-if="goodList.length">
                  <div
                    class="item"
                    v-for="(item, index) in goodList"
                    :key="index"
                  >
                    <div class="itemtitle">{{ item.department_name }}</div>
                    <div class="gooditembox">
                      <div
                        v-for="(i, ind) in item.list"
                        :key="ind"
                        :class="i.isCheck ? 'checkitem' : 'gooditem'"
                        @click="checkItem(i)"
                      >
                        {{ i.be_good_at_name }}
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div
                    style="
                      height: 220px;
                      display: flex;
                      justify-content: center;
                    "
                  >
                    暂无数据
                  </div>
                </template>
                <div class="closegood" @click="closegoodlist">关闭</div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="个人简介" prop="introduction">
            <el-input
              type="textarea"
              v-model="ruleForm.introduction"
              maxlength="500"
              show-word-limit
              class="myinput"
              :autosize="{ minRows: 5, maxRows: 5 }"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="margin-top: 40px; text-align: center; padding-bottom: 20px">
      <el-button @click="close" plain>取 消</el-button>
      <el-button type="primary" @click="submit('ruleForm')" :disabled="!edit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import platform from "../../../api/platform";
import doctor from "../../../api/doctor";
import constant from "../../../service/common/constant";
import axios from "../../../service/axios/axios";
import _ from "lodash";
export default {
  data() {
    return {
      dialog: true,
      goodlistKeyword: "",
      goodList: [],
      showgoodlist: false,
      goodTags: [],
      edit: false,
      info: {},
      ruleForm: {
        doctor_id: this.$route.query.doctor_id,
        doctor_name: "",
        head_img: "",
        sex: "",
        hospital: "",
        be_good_at: "",
        introduction: "",
      },
      rules: {
        head_img: [
          {
            required: true,
            message: "请上传头像",
            trigger: "blur",
          },
        ],
        hospital: [
          { required: true, message: "请填写目前执业的医院", trigger: "blur" },
        ],
        doctor_name: [
          { required: true, message: "请输入医生姓名", trigger: "blur" },
        ],
        introduction: [
          { required: true, message: "请填写个人简介", trigger: "blur" },
          { min: 10, max: 500, message: "至少输入10个字", trigger: "blur" },
        ],
      },
      uploadExtraData: {
        img_type: 1,
        suffix: ".jpg",
      },
      head_img: "",
    };
  },
  watch: {
    goodTags(val) {
      setTimeout(() => {
        let h = document.getElementById("begoodat").offsetHeight;
        document.getElementById("begoodatitem").style.marginBottom =
          h - 20 + "px";
      }, 50);
      let good_name_arr = val.map((item) => {
        return item.be_good_at_name;
      });
      if (
        this.ruleForm.doctor_name != this.info.doctor_name ||
        this.ruleForm.head_img != this.info.head_img ||
        this.ruleForm.sex != this.info.sex ||
        this.ruleForm.hospital != this.info.hospital ||
        this.ruleForm.introduction != this.info.introduction ||
        good_name_arr.toString() != this.info.be_good_at_name
      ) {
        this.edit = true;
      } else {
        this.edit = false;
      }
    },
    "ruleForm.doctor_name": function (val) {
      let good_name_arr = this.goodTags.map((item) => {
        return item.be_good_at_name;
      });
      if (
        this.ruleForm.doctor_name != this.info.doctor_name ||
        this.ruleForm.head_img != this.info.head_img ||
        this.ruleForm.sex != this.info.sex ||
        this.ruleForm.hospital != this.info.hospital ||
        this.ruleForm.introduction != this.info.introduction ||
        good_name_arr.toString() != this.info.be_good_at_name
      ) {
        this.edit = true;
      } else {
        this.edit = false;
      }
    },
    "ruleForm.head_img": function (val) {
      let good_name_arr = this.goodTags.map((item) => {
        return item.be_good_at_name;
      });
      if (
        this.ruleForm.doctor_name != this.info.doctor_name ||
        this.ruleForm.head_img != this.info.head_img ||
        this.ruleForm.sex != this.info.sex ||
        this.ruleForm.hospital != this.info.hospital ||
        this.ruleForm.introduction != this.info.introduction ||
        good_name_arr.toString() != this.info.be_good_at_name
      ) {
        this.edit = true;
      } else {
        this.edit = false;
      }
    },
    "ruleForm.sex": function (val) {
      let good_name_arr = this.goodTags.map((item) => {
        return item.be_good_at_name;
      });
      if (
        this.ruleForm.doctor_name != this.info.doctor_name ||
        this.ruleForm.head_img != this.info.head_img ||
        this.ruleForm.sex != this.info.sex ||
        this.ruleForm.hospital != this.info.hospital ||
        this.ruleForm.introduction != this.info.introduction ||
        good_name_arr.toString() != this.info.be_good_at_name
      ) {
        this.edit = true;
      } else {
        this.edit = false;
      }
    },
    "ruleForm.hospital": function (val) {
      let good_name_arr = this.goodTags.map((item) => {
        return item.be_good_at_name;
      });
      if (
        this.ruleForm.doctor_name != this.info.doctor_name ||
        this.ruleForm.head_img != this.info.head_img ||
        this.ruleForm.sex != this.info.sex ||
        this.ruleForm.hospital != this.info.hospital ||
        this.ruleForm.introduction != this.info.introduction ||
        good_name_arr.toString() != this.info.be_good_at_name
      ) {
        this.edit = true;
      } else {
        this.edit = false;
      }
    },
    "ruleForm.introduction": function (val) {
      let good_name_arr = this.goodTags.map((item) => {
        return item.be_good_at_name;
      });
      if (
        this.ruleForm.doctor_name != this.info.doctor_name ||
        this.ruleForm.head_img != this.info.head_img ||
        this.ruleForm.sex != this.info.sex ||
        this.ruleForm.hospital != this.info.hospital ||
        this.ruleForm.introduction != this.info.introduction ||
        good_name_arr.toString() != this.info.be_good_at_name
      ) {
        this.edit = true;
      } else {
        this.edit = false;
      }
    },
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "api/platform/upload/uploadFile";
      } else {
        return "platform/upload/uploadFile";
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform", "appid"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  mounted() {
    this.getInfo();
    this.getGoodList();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    //获取医生擅长列表
    getGoodList() {
      doctor
        .getDoctorBeGoodsAt({ be_good_at_name: this.goodlistKeyword })
        .then((res) => {
          if (JSON.stringify(res.data.list) == "{}") {
            this.goodList = [];
            return;
          }
          this.goodList = res.data.list.map((item) => {
            item.list.map((i) => {
              i.isCheck = false;
              return i;
            });
            return item;
          });
          let check_id = this.goodTags.map((item) => {
            return item.be_good_at_id;
          });
          this.goodList.forEach((item) => {
            item.list.forEach((i) => {
              i.isCheck = false;
              if (check_id.includes(i.be_good_at_id)) {
                i.isCheck = true;
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //选择擅长列表里面的
    checkItem(i) {
      if (this.goodTags.length >= 40) {
        this.$message.error("最多选择40项擅长项");
        return;
      }
      i.isCheck = !i.isCheck;
      if (i.isCheck) {
        this.goodTags.push(i);
        setTimeout(() => {
          let h = document.getElementById("begoodat").offsetHeight;
          document.getElementById("begoodatitem").style.marginBottom =
            h - 20 + "px";
        }, 50);
      } else {
        this.goodTags.splice(this.goodTags.indexOf(i), 1);
        setTimeout(() => {
          let h = document.getElementById("begoodat").offsetHeight;
          document.getElementById("begoodatitem").style.marginBottom =
            h - 20 + "px";
        }, 400);
      }
    },
    //删除单个标签
    handleClose(tag) {
      this.goodTags.splice(this.goodTags.indexOf(tag), 1);
      setTimeout(() => {
        let h = document.getElementById("begoodat").offsetHeight;
        document.getElementById("begoodatitem").style.marginBottom =
          h - 30 + "px";
      }, 400);
      let check_id = this.goodTags.map((item) => {
        return item.be_good_at_id;
      });
      this.goodList.forEach((item) => {
        item.list.forEach((i) => {
          i.isCheck = false;
          if (check_id.includes(i.be_good_at_id)) {
            i.isCheck = true;
          }
        });
      });
    },
    //关闭擅长列表
    closegoodlist() {
      setTimeout(() => {
        this.showgoodlist = false;
      }, 100);
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        //半路径
        this.ruleForm.head_img = res.data.pic;
        this.head_img = res.data.path;
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error("上传图片只能是 jpg, png, jpeg 格式!");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      this.uploadExtraData.img_type = 1;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    requestImg(src, imgname) {
      let value = this.getUrlParam("resources_id", src);
      this.axios
        .get("doctor/cms/getImg", {
          params: { resources_id: value },
        })
        .then((res) => {
          this[imgname] = res;
        });
    },
    getUrlParam(key, url) {
      var reg = new RegExp("(^|\\?|&)" + key + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    //提交
    submit(formName) {
      if (this.goodTags.length > 40) {
        this.$message.error("最多选择40项擅长项");
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          let good_id_arr = this.goodTags.map((item) => {
            return item.be_good_at_id;
          });
          let good_name_arr = this.goodTags.map((item) => {
            return item.be_good_at_name;
          });
          data.be_good_at = good_id_arr.toString();
          data.be_good_at_name = good_name_arr.toString();
          this.axios
            .post("platform/doctor/modifyDoctorInfo", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("医生信息已修改");
                this.$emit("editInfo");
                this.close();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取认证详情
    getInfo() {
      let doctor_id = this.$route.query.doctor_id;
      this.axios
        .post("platform/doctor/doctorItem", { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.info = _.pick(info, [
              "doctor_name",
              "doctor_name_str",
              "sex",
              "head_img",
              "hospital",
              "introduction",
              "be_good_at_name",
            ]);
            this.ruleForm = _.pick(info, [
              "doctor_name",
              "doctor_name_str",
              "sex",
              "head_img",
              "hospital",
              "introduction",
            ]);
            this.ruleForm = Object.assign(this.ruleForm, {
              doctor_id: this.$route.query.doctor_id,
              be_good_at: "",
            });
            this.ruleForm.doctor_name = this.ruleForm.doctor_name_str;
            this.head_img = info.head_img;
            this.goodTags = info.be_good_at;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.myinput {
  width: 450px;
}
.selectgoodlist {
  width: 450px;
  min-height: 40px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  border-radius: 4px;
  &:hover {
    border: 1px solid #669961;
  }
}
// .goodlist {
//   background: #fff;
//   box-sizing: border-box;
//   width: 398px;
//   height: 300px;
//   overflow-y: scroll;
//   box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
//   border-radius: 4px;
//   border: solid 1px #c0c4cc;
//   margin-top: 10px;
//   z-index: 100000000;
//   position: relative;
//   .item {
//     margin-bottom: 24px;
//     padding: 0 5px 0 20px;
//   }
//   .closegood {
//     height: 30px;
//     line-height: 30px;
//     width: 378px;
//     background-color: #e6efeb;
//     color: #699b64;
//     text-align: center;
//     cursor: pointer;
//     position: sticky;
//     bottom: 0px;
//   }
// }
.goodlist {
  background: #fff;
  box-sizing: border-box;
  width: 430px;
  height: 300px;
  overflow-y: scroll;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: solid 1px #c0c4cc;
  margin-top: 10px;
  z-index: 100000000;
  position: relative;
  .search {
    background-color: #fff;
    padding: 4px;
    position: sticky;
    top: 0;
  }
  .item {
    margin-bottom: 24px;
    padding: 0 5px 0 20px;
  }
  .closegood {
    height: 30px;
    line-height: 30px;
    width: 100%;
    background-color: #e6efeb;
    color: #699b64;
    text-align: center;
    cursor: pointer;
    position: sticky;
    bottom: 0px;
  }
}
.itemtitle {
  color: #191c21;
  font-weight: 600;
  height: 30px;
  line-height: 30px;
}
.gooditembox {
  display: flex;
  flex-wrap: wrap;
  .gooditem {
    margin-right: 10px;
    cursor: pointer;
    height: 30px;
    line-height: 30px;
    margin-bottom: 6px;
    padding: 0 5px;
    box-sizing: border-box;
  }
}
.checkitem {
  background-color: #e6efeb;
  margin-right: 10px;
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  color: #669961;
  margin-bottom: 6px;
  padding: 0 5px;
  box-sizing: border-box;
}

.headimg {
  width: 100px;
  height: 100px;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  .avatar {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    margin-top: 12px;
  }
  .uploader-icon {
    font-size: 30px;
    color: #d6d6d6;
  }
}
</style>
<style lang="scss">
.el-tag + .el-tag {
  margin-left: 10px;
}
.container .el-tag.el-tag--info {
  background-color: #fafafa;
  border-color: #e8e8e8;
  color: #191c21;
}
</style>
